import * as React from "react";
import "./../index.css";
import "./../fonts/Bakerie/BakerieSmoothCondensed-Black.otf";
import {
  Button,
  Container,
  Row,
  Col,
  Table,
  Stack
} from "react-bootstrap";
import { getDocs, collection, query, orderBy, Timestamp } from "firebase/firestore";
import { database } from '../firebase-config';

import Modal from "react-modal";
import { ProductForm } from './ProductForm';
import { roundToDollars } from '../utils/MoneyUtils';
import { CustomizedTypeahead } from './CustomizedTypeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import { getRecipeMapFromDB } from "../data/RecipeData";
import moment from "moment";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Products, getProduct, getProducts, saveProduct, recordHistory, getDocData } from "../data/ProductData";
import ToggleButton from 'react-toggle-button';

export class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: new Products(),
      recipeMap: new Map(),
      recipeMapNoDeleted: new Map(),
      allDocs: [],
      docRef: "",
      docMap: new Map(),
      refMap: new Map(),
      options: new Array(),
      previousRef: "",
      isDeleteConfirmOpen: false,
      deleteDocName: "",
      deleteDocRef: "",
      mode: "Add",
      showForm: false,
      didSave: true,
      currentlySelectedId: '',
      chosenCategory: "All",
      show_deleted: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.COLLECTION = "products";
  }

  toggleShowForm = () => {
    this.setState(
      {
        showForm: !this.state.showForm,
        docMap: new Map(),
        didSave: true,
      },
      () => {
        this.readProducts(this.state.chosenCategory);
      }
    );
  };

  toggleMode = (mode) => {
    this.setState({
      docRef: "",
      mode: mode,
      showForm: true,
      didSave: false,
    });
  };

  toggleDeleteModal = (docRef, name) => {

    this.setState({
      deleteDocRef: docRef,
      deleteDocName: name,
      isDeleteConfirmOpen: !this.state.isDeleteConfirmOpen,
    });
  };

  handleUpdate = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: "Edit",
      didSave: false,
    });
  };

  handleCopy = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: 'Copy',
      didSave: false,
    });
  }

  handleView = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: "View",
      didSave: true,
    });
  };
  async buildFindOptions() {
    let tempOptions = new Array();
    try {
      const docQuery = query(collection(database, this.COLLECTION), orderBy("name", "asc"));
      const querySnapshot = await getDocs(docQuery);
      querySnapshot.forEach((doc) => {
        let option = { id: doc.id, value: doc.data().name };
        tempOptions.push(option);
      });
      this.setState({
        options: tempOptions,
      });
    } catch (e) {
      console.log("Error getting cached document:", e);
    }
  }
  handleDelete = async (docRef) => {
    let newHistoryList = new Array();
    let productDoc = await getProduct(docRef);
    let product = productDoc.data();
    product.is_deleted = !product.is_deleted;
    newHistoryList = product.history;
    let now = Timestamp.now();
    await recordHistory(newHistoryList, now, product, docRef);
    product.history = newHistoryList;

    let docData = getDocData(product);

    await saveProduct(docRef, docData)
    this.readProducts(this.state.chosenCategory);

  }

  async readProducts(category) {
    let categoryString = 'All'
    if (category) {
      categoryString = category;
    }
    let products = await getProducts(categoryString, this.state.show_deleted);
    this.setState({
      products: products,
      chosenCategory: categoryString,
    });
  }



  async loadData() {
    this.readProducts();
    let recipeMaps = await getRecipeMapFromDB();
    this.setState({
      recipeMap: recipeMaps.recipeMap,
      recipeMapNoDeleted: recipeMaps.recipeMapNoDeleted
    })
  }

  componentDidMount() {
    this.loadData();
    window.addEventListener("beforeunload", this.beforeunload.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.beforeunload.bind(this));
  }

  beforeunload(e) {
    if (!this.state.didSave) {
      e.preventDefault();
      e.returnValue = "";
    }
  }

  scrollToView(ref) {
    if (this.state.previousRef !== '' && this.state.previousRef.current) {
      let oldRef = this.state.previousRef;
      oldRef.current.style.background = 'white';
      this.setState({
        previousRef: "",
      })
    }
    setTimeout(() => {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      ref.current.style.background = 'gray';
      this.setState({
        previousRef: ref,
      })
    });
  }

  renderTableRow = (docRef, doc) => {
    let recipeCostPerItemHigh = this.state.recipeMap.get(doc.recipe).cost_per_item_high;
    let recipeCostPerItemLow = this.state.recipeMap.get(doc.recipe).cost_per_item_low;
    let productCostHigh = doc.packaging_cost + recipeCostPerItemHigh * doc.recipe_qty;
    let productCostLow = doc.packaging_cost + recipeCostPerItemLow * doc.recipe_qty;
    let recipeMakes = this.state.recipeMap.get(doc.recipe).makes_qty;
    let name = doc.name;
    let ingredientLabelFile = "";
    if (doc.ingredient_label_file) {
      ingredientLabelFile =
        "https://drive.google.com/uc?export=view&id=" +
        doc.ingredient_label_file;
    }
    let nameLabelFile = "";
    if (doc.name_label_file) {
      nameLabelFile =
        "https://drive.google.com/uc?export=view&id=" + doc.name_label_file;
    }
    let lastUpdatedString = "";
    if (doc.last_update) {
      lastUpdatedString = moment(doc.last_update.toDate()).format('MM/DD/YYYY HH:mm:ss');
    }
    let deleteText = "";
    let deleted = "";
    if (doc.is_deleted) {
      deleteText = "Undelete"
      deleted = "Y"
    } else {
      deleteText = "Delete"
      deleted = "N"
    }

    return (
      <tr key={docRef} ref={this.state.products.refMap.get(docRef)} id={docRef}>
        <td>{doc.name}</td>
        <td>{roundToDollars(doc.price)}</td>
        <td>{doc.on_website ? "Y" : "N"}</td>
        <td>{roundToDollars(productCostHigh)}</td>
        <td>{roundToDollars(productCostLow)}</td>
        <td>{this.state.recipeMap.get(doc.recipe).name}</td>
        <td>{recipeMakes}</td>
        <td>{doc.recipe_qty}</td>
        <td>{roundToDollars(recipeCostPerItemHigh)}</td>
        <td>{roundToDollars(recipeCostPerItemLow)}</td>
        <td>{this.state.recipeMap.get(doc.recipe).low_profit_index}</td>
        <td>{roundToDollars(this.state.recipeMap.get(doc.recipe).total_ingredient_cost)}</td>
        <td>{roundToDollars(doc.packaging_cost)}</td>
        <td>{lastUpdatedString}</td>
        {this.state.show_deleted && <td>{deleted}</td>}
        <td>
          <DropdownButton variant="dark" id="dropdown-basic-button" title="Actions">
            <Dropdown.Item variant="dark" onClick={() => { this.handleView(docRef) }}>View</Dropdown.Item>
            <Dropdown.Item variant="dark" onClick={() => { this.handleUpdate(docRef) }}>Edit</Dropdown.Item>
            <Dropdown.Item variant="dark" onClick={() => { this.handleCopy(docRef) }}>Copy</Dropdown.Item>
            <Dropdown.Item variant="dark" onClick={() => { this.handleDelete(docRef) }}>{deleteText}</Dropdown.Item>
            {doc.ingredient_label_file && (
              <Dropdown.Item variant="dark" href={ingredientLabelFile} download={ingredientLabelFile}>Ingredient & Disclaimer Labels</Dropdown.Item>
            )}
            {doc.name_label_file && (
              <Dropdown.Item variant="dark" href={nameLabelFile} download={nameLabelFile}>Name Labels</Dropdown.Item>
            )}
          </DropdownButton>
        </td>
      </tr >
    );
  };

  render() {
    let docMap = this.state.products.docMap;

    return (
      <>
        {
          /* 
          * Product List
          */
        }
        <Stack gap={3}>
          {this.state.showForm &&
            <ProductForm
              recipeMap={this.state.recipeMapNoDeleted}
              docRef={this.state.docRef}
              mode={this.state.mode}
              toggleForm={() => {
                this.toggleShowForm();
              }}
            />
          }
          {!this.state.showForm &&
            <Container fluid>
              <Row className="justify-content-md-left">
                <Col>
                  <h2>Products:</h2>
                </Col>
                <Col>
                  <Button variant="dark" onClick={() => { this.toggleMode('Add') }}>Add New Product</Button>
                </Col>
                <Col>
                  <DropdownButton variant="dark" id="dropdown-basic-button" title="Filter by Category">
                    <Dropdown.Item variant="dark" onClick={() => { this.readProducts(undefined) }}>All</Dropdown.Item>
                    <Dropdown.Item variant="dark" onClick={() => { this.readProducts('Bread') }}>Bread</Dropdown.Item>
                    <Dropdown.Item variant="dark" onClick={() => { this.readProducts('Cake') }}>Cake</Dropdown.Item>
                    <Dropdown.Item variant="dark" onClick={() => { this.readProducts('Cookies') }}>Cookies</Dropdown.Item>
                    <Dropdown.Item variant="dark" onClick={() => { this.readProducts('Gluten Free') }}>Gluten Free</Dropdown.Item>
                    <Dropdown.Item variant="dark" onClick={() => { this.readProducts('Quick Breads') }}>Quick Breads</Dropdown.Item>
                    <Dropdown.Item variant="dark" onClick={() => { this.readProducts('Rolls') }}>Rolls</Dropdown.Item>
                  </DropdownButton>
                </Col>
                <Col md="auto">
                  <b>Category:</b> {this.state.chosenCategory}
                </Col>
                <Col>
                  <label htmlFor="show_deleted">Show Deleted?</label>
                  <ToggleButton
                    id="show_deleted"
                    inactiveLabel={'No'}
                    activeLabel={'Yes'}
                    value={this.state.show_deleted}
                    onToggle={(value) => {
                      this.setState({
                        show_deleted: !this.state.show_deleted,
                      }, () => {
                        this.readProducts(this.state.chosenCategory);
                      })
                    }} />
                </Col>
                <Col md="auto">
                  Find:
                </Col>
                <Col md="auto">
                  <CustomizedTypeahead
                    onChange={(selected) => {
                      //console.log("selected" + selected);
                      if (selected.length > 0) {
                        let ref = this.state.products.refMap.get(selected[0].id);
                        this.scrollToView(ref);
                      }
                    }}
                    id='product_typeahead'
                    align='left'
                    labelKey={'value'}
                    options={this.state.products.options}
                  />
                </Col>
              </Row>
            </Container>
          }
          <Modal
            className="modalDialog"
            isOpen={this.state.isDeleteConfirmOpen}
            onRequestClose={this.toggleModal}
            contentLabel="My dialog"
          >
            <div>Delete {this.state.deleteDocName}?</div>
            <Button
              variant="dark"
              size="sm"
              onClick={() => {
                this.toggleDeleteModal();
              }}
            >
              Cancel
            </Button>{" "}
            <Button
              variant="dark"
              size="sm"
              onClick={() => {
                this.handleDelete(this.state.deleteDocRef);
              }}
            >
              Confirm
            </Button>
          </Modal>
          {!this.state.showForm && (
            <div className="scrollingTable">
              <Table bordered hover>
                <thead>
                  <tr className='header'>
                    <th className='table-header'>Name</th>
                    <th className='table-header'>Our Price</th>
                    <th className='table-header'>Website?</th>
                    <th className='table-header'>Cost High</th>
                    <th className='table-header'>Cost Low</th>
                    <th className='table-header'>Recipe</th>
                    <th className='table-header'>Recipe Makes</th>
                    <th className='table-header'>Quantity per Product Pkg</th>
                    <th className='table-header'>Recipe Cost High</th>
                    <th className='table-header'>Recipe Cost Low</th>
                    <th className='table-header'>Recipe Low Profit Index</th>
                    <th className='table-header'>Recipe Ingredient Cost</th>
                    <th className='table-header'>Packaging Cost</th>
                    <th className='table-header'>Last Update</th>
                    {this.state.show_deleted && <th className='table-header'>Deleted?</th>}
                    <th className='table-header'></th>
                  </tr>
                </thead>
                <tbody>
                  {[...docMap].map(([key, value]) => {
                    return this.renderTableRow(key, value);
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </Stack>
      </>
    );
  }
}
